import React from 'react';
import { SEGMENT_FILL, SEGMENT_VALUE_TEXT } from '../theme';

/**
 * The abnormality-count column chart: one column per bucket, counts above and a labelled axis below.
 *
 * Built as a three-row CSS grid (values / plot area / axis) rather than a chart library, so the columns
 * line up with the axis cells at any width and print without a canvas.
 */
const ColumnChart = ({ columns, plotHeight = 230 }) => (
  <div
    className='grid gap-x-[22px] gap-y-ds-3'
    style={{
      gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
      gridTemplateRows: `auto ${plotHeight}px auto`,
    }}
  >
    {columns.map((column, index) => (
      <div
        key={`value-${column.tick}`}
        className={`text-center font-jetbrains-mono text-[17px] font-semibold tabular-nums ${
          SEGMENT_VALUE_TEXT[index % SEGMENT_VALUE_TEXT.length]
        }`}
      >
        {column.value}
      </div>
    ))}

    {columns.map((column, index) => (
      <div
        key={`bar-${column.tick}`}
        data-tip={column.tip}
        className={`self-end rounded-t-[8px] ${SEGMENT_FILL[index % SEGMENT_FILL.length]}`}
        style={{ height: `${column.length}%` }}
      />
    ))}

    {columns.map((column, index) => (
      <div key={`axis-${column.tick}`} className='border-t border-gray-300 pt-[10px] text-center'>
        <div className='font-jetbrains-mono text-[13px] font-semibold text-gray-900'>{column.tick}</div>
        <div
          className={`mt-[3px] text-[11px] ${
            index === columns.length - 1 ? 'text-ds-rose-dk' : 'text-gray-600'
          }`}
        >
          {column.caption}
        </div>
      </div>
    ))}
  </div>
);

export default ColumnChart;
